import axios from "axios";
import store from "../store/store";
import {corporateInternetBankingBaseUrl,corporateInternetBankingBaseUrl2, cbanklocal} from "../app.config"
//import router from "../router";


const apiClient = axios.create({
    baseURL: corporateInternetBankingBaseUrl,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
});
const apiClient2 = axios.create({
    baseURL: corporateInternetBankingBaseUrl2,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
});


const apiClient3 = axios.create({
    baseURL: cbanklocal,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
    }
});

apiClient3.interceptors.request.use(config => {
    store.getters["auth/getUserTokenFromLocalStorage"] != null ? config.headers.Authorization = store.getters["auth/getUserTokenFromLocalStorage"] : '';
    return config;
});

// apiClient3.interceptors.response.use(response => {
//     response.responsecode === "92" ?  router.push("/logon") : ''
// });

// https://cors-anywhere.herokuapp.com

export default {
    callReadAllAccountApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient2.post("/readAccount", payload);
    },
    callCbankReadAllAccountApi(payload) {
        // console.log("Service Payload ==>>", payload);
        // const header  =  { Authorization : store.getters["auth/getUserTokenFromLocalStorage"]  };
        return apiClient3.post("transaction/getaccounts", payload);
    },
    callGetBatchStatusApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("readAccounts", payload);
    },
    callGetCompanyBeneficiaries(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient3.post("companies/beneficiaries", payload);
    },
    callGetBatchTransactionApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient.post("readCompanies", payload);
    },
    callGetStatementsApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient3.post("transaction/getstatements", payload);
    },
    fetchStatementsApi(payload) {
        // console.log("Service Payload ==>>", payload)
        return apiClient3.post("transaction/fetchstatements", payload);
    }
};
